export const NVBB_DROPPOINT_LOCATION_OPTIONS = [
  {
    text: 'บางบอน-เอกชัย (PTT-BB3)',
    desc: `📍บางบอน-เอกชัย (PTT-BB3)📍`,
    value: 'บางบอน-เอกชัย (PTT-BB3)',
    location: [
      {
        lat_long: '13.656371920694491, 100.39405052096835',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop1',
    timePeriod: '10:00 - 15:00',
    displayString: '99, 99 ถ. เอกชัย แขวง บางบอน เขตบางบอน กรุงเทพมหานคร 10150'
  },
  {
    text: 'พุทธมณฑล-สนามหลวง 2 (LT)',
    desc: `📍พุทธมณฑล-สนามหลวง 2 (LT)📍`,
    value: 'พุทธมณฑล-สนามหลวง 2 (LT)',
    location: [
      {
        lat_long: '13.747239687663944, 100.35444366793094',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 20,
    filterName: 'drop2',
    timePeriod: '10:00 - 15:00',
    displayString: '76/4 ถนนทวีวัฒนา แขวงทวีวัฒนา เขตทวีวัฒนา, กรุงเทพมหานคร 10170'
  },
  {
    text: 'กาญจนาภิเษก (ES)',
    desc: `📍กาญจนาภิเษก (ES)📍`,
    value: 'กาญจนาภิเษก (ES)',
    location: [
      {
        lat_long: '13.776126053780834, 100.40910746731954',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop3',
    timePeriod: '10:00 - 15:00',
    displayString: '136, 4 ถ. กาญจนาภิเษก แขวง บางระมาด เขตตลิ่งชัน กรุงเทพมหานคร 10170'
  },
  {
    text: 'กาญจนาภิเษก (PT)',
    desc: `📍กาญจนาภิเษก (PT)📍`,
    value: 'กาญจนาภิเษก (PT)',
    location: [
      {
        lat_long: '13.670219396886246, 100.40551465678783',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop4',
    timePeriod: '10:00 - 15:00',
    displayString: '95/1 ถ. กาญจนาภิเษก แขวง บางบอน เขตบางบอน กรุงเทพมหานคร 10150'
  },
  {
    text: 'กัลปพฤกษ์ (JF)',
    desc: `📍กัลปพฤกษ์ (JF)📍`,
    value: 'กัลปพฤกษ์ (JF)',
    location: [
      {
        lat_long: '13.703614387449818, 100.44622539737809',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop5',
    timePeriod: '10:00 - 15:00',
    displayString: '16/3 ถนน กัลปพฤกษ์ แขวง บางขุนเทียน เขตจอมทอง กรุงเทพมหานคร 10150'
  },
  {
    text: 'กัลปพฤกษ์ (HP)',
    desc: `📍กัลปพฤกษ์ (HP)📍`,
    value: 'กัลปพฤกษ์ (HP)',
    location: [
      {
        lat_long: '13.695236978106088, 100.4361380758398',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop6',
    timePeriod: '10:00 - 15:00',
    displayString: '604 ถนน กัลปพฤกษ์ แขวง บางหว้า เขตภาษีเจริญ กรุงเทพมหานคร 10160'
  },
  {
    text: 'กัลปพฤกษ์ (PTT-MT)',
    desc: `📍กัลปพฤกษ์ (PTT-MT)📍`,
    value: 'กัลปพฤกษ์ (PTT-MT)',
    location: [
      {
        lat_long: '13.707986073281086, 100.45023882793562',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop7',
    timePeriod: '10:00 - 15:00',
    displayString: 'ถนน กัลปพฤกษ์ แขวง บางหว้า เขตภาษีเจริญ กรุงเทพมหานคร 10160'
  },
  {
    text: 'พระราม 2 (IND)',
    desc: `📍พระราม 2 (IND)📍`,
    value: 'พระราม 2 (IND)',
    location: [
      {
        lat_long: '13.66599004120337, 100.44361782569385',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop8',
    timePeriod: '10:00 - 15:00',
    displayString: '120 ถ. พระรามที่ 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
  },
  {
    text: 'พระราม 2 (ธอส)',
    desc: `📍พระราม 2 (ธอส)📍`,
    value: 'พระราม 2 (ธอส)',
    location: [
      {
        lat_long: '13.676941527721759, 100.4618235138312',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop9',
    timePeriod: '10:00 - 15:00',
    displayString: '73 พระราม 2 ซอย 30 แขวง บางมด เขตจอมทอง กรุงเทพมหานคร 10150'
  },
  {
    text: 'สาทรเหนือ (CT)',
    desc: `📍สาทรเหนือ (CT)📍`,
    value: 'สาทรเหนือ (CT)',
    location: [
      {
        lat_long: '13.725104736149751, 100.54014915699695',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop10',
    timePeriod: '10:00 - 15:00',
    displayString: 'ถ. สาทรเหนือ แขวง สีลม เขตบางรัก กรุงเทพมหานคร 10500'
  },
  {
    text: 'พระราม 4 (BC-XT)',
    desc: '📍พระราม 4 (BC-XT)📍',
    value: 'พระราม 4 (BC-XT)',
    location: [
      {
        lat_long: '13.718875251422839, 100.5690463825553',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop11',
    timePeriod: '12:00 - 16:00',
    displayString: '2929 ถนนพระรามที่ ๔ แขวง คลองตัน เขตคลองเตย กรุงเทพมหานคร 10110'
  },
  {
    text: 'พระโขนง-สุขุมวิท 99 (บจ)',
    desc: '📍พระโขนง-สุขุมวิท 99 (บจ)📍',
    value: 'พระโขนง-สุขุมวิท 99 (บจ)',
    location: [
      {
        lat_long: '13.69271004933028, 100.60770128539107',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop12',
    timePeriod: '12:00 - 16:00',
    displayString: '2999/1 ถ. สุขุมวิท แขวง บางจาก เขตพระโขนง กรุงเทพมหานคร 10260'
  },
  {
    text: 'ประดิษฐ์มนูญธรรม (PT)',
    desc: '📍ประดิษฐ์มนูญธรรม (PT)📍',
    value: 'ประดิษฐ์มนูญธรรม (PT)',
    location: [
      {
        lat_long: '13.792560628471398, 100.61066882025472',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop13',
    timePeriod: '12:00 - 16:00',
    displayString: 'QJV6+27F แขวง สะพานสอง เขตวังทองหลาง กรุงเทพมหานคร 10310'
  },
  {
    text: 'ประดิษฐ์มนูญธรรม (ES-ND)',
    desc: '📍ประดิษฐ์มนูญธรรม (ES-ND)📍',
    value: 'ประดิษฐ์มนูญธรรม (ES-ND)',
    location: [
      {
        lat_long: '13.821287960180761, 100.62541106627015',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop14',
    timePeriod: '14:00 - 18:00',
    displayString: '361 ซอย ประดิษฐ์มนูญธรรม แขวงลาดพร้าว เขตลาดพร้าว กรุงเทพมหานคร 10230'
  },
  {
    text: 'รามอินทรา (PTT-สน)',
    desc: '📍รามอินทรา (PTT-สน)📍',
    value: 'รามอินทรา (PTT-สน)',
    location: [
      {
        lat_long: '13.847092615988172, 100.64731867852707',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop15',
    timePeriod: '14:00 - 18:00',
    displayString: '27, 1 ถ. รามอินทรา แขวง รามอินทรา เขตคันนายาว กรุงเทพมหานคร 10230'
  },
  {
    text: 'รามอินทรา (PTT-กท)',
    desc: '📍รามอินทรา (PTT-กท)📍',
    value: 'รามอินทรา (PTT-กท)',
    location: [
      {
        lat_long: '13.845379171116159, 100.63645474826342',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop16',
    timePeriod: '14:00 - 18:00',
    displayString: '340 ถนน ประดิษฐ์มนูธรรม แขวง ท่าแร้ง เขตบางเขน กรุงเทพมหานคร 10220'
  },
  {
    text: 'หลักสี่ (PTT)',
    desc: '📍หลักสี่ (PTT)📍',
    value: 'หลักสี่ (PTT)',
    location: [
      {
        lat_long: '13.889100579376729, 100.5728753568575',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop17',
    timePeriod: '14:00 - 18:00',
    displayString: '99/115-120 ถ. แจ้งวัฒนะ แขวง ทุ่งสองห้อง เขต หลักสี่ กรุงเทพมหานคร 10210'
  },
  {
    text: 'หลักสี่ (SHLL)',
    desc: '📍หลักสี่ (SHLL)📍',
    value: 'หลักสี่ (SHLL)',
    location: [
      {
        lat_long: '13.89205596903052, 100.56229360999114',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop18',
    timePeriod: '14:00 - 18:00',
    displayString: '200/1 ถ. แจ้งวัฒนะ แขวง ทุ่งสองห้อง เขต หลักสี่ กรุงเทพมหานคร 10210'
  },
  {
    text: 'งามวงศ์วาน-พงษ์เพชร (LTGF)',
    desc: '📍งามวงศ์วาน-พงษ์เพชร (LTGF)📍',
    value: 'งามวงศ์วาน-พงษ์เพชร (LTGF)',
    location: [
      {
        lat_long: '13.8548247392373, 100.54418646793977',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop19',
    timePeriod: '14:00 - 18:00',
    displayString: '99/9 หมู่ที่ 3 ถนน งามวงศ์วาน ตำบลบางเขน อำเภอเมืองนนทบุรี นนทบุรี 11000'
  },
  {
    text: 'รัตนาธิเบศร์-ไทรม้า (บจ108)',
    desc: '📍รัตนาธิเบศร์-ไทรม้า (บจ108)📍',
    value: 'รัตนาธิเบศร์-ไทรม้า (บจ108)',
    location: [
      {
        lat_long: '13.874392048491998, 100.45798703509423',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop20',
    timePeriod: '14:00 - 18:00',
    displayString: '79 11-12 ซอย หมู่ 3 ตำบล บางรักน้อย อำเภอเมืองนนทบุรี นนทบุรี 11000'
  },
  {
    text: 'รัตนาธิเบศร์-บางรักใหญ่ (JF)',
    desc: '📍รัตนาธิเบศร์-บางรักใหญ่ (JF)📍',
    value: 'รัตนาธิเบศร์-บางรักใหญ่ (JF)',
    location: [
      {
        lat_long: '13.875831600000069, 100.4403315825482',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop21',
    timePeriod: '14:00 - 18:00',
    displayString: 'ถนน บางบัวทอง - สุพรรณบุรี ตำบล บางรักใหญ่ อำเภอบางบัวทอง นนทบุรี 11110'
  },
  {
    text: 'ราชพฤกษ์ (TH-W)',
    desc: '📍ราชพฤกษ์ (TH-W)📍',
    value: 'ราชพฤกษ์ (TH-W)',
    location: [
      {
        lat_long: '13.821225776710818, 100.44972888084453',
        id: '2021-08-30T05:38:54.613Z'
      }
    ],
    shopCharg: 30,
    filterName: 'drop22',
    timePeriod: '*วันพฤ 10:00 - 15:00 ,วันอื่น 14:00 - 18:00',
    displayString: '189 หมู่ที่ 2 ถนน ราชพฤกษ์ ตำบล บางขุนกอง อำเภอบางกรวย นนทบุรี 11130'
  },
  {
    text: 'พระรามสอง-พันท้ายนรสิงห์',
    desc: '📍พระรามสอง-พันท้ายนรสิงห์📍',
    value: 'พระรามสอง-พันท้ายนรสิงห์',
    location: [{ lat_long: '13.593112, 100.368572', id: '2021-08-30T05:38:54.613Z' }],
    shopCharg: 30,
    filterName: 'drop23',
    timePeriod: '10:00 - 15:00',
    displayString: 'ตำบล พันท้ายนรสิงห์ อำเภอเมืองสมุทรสาคร สมุทรสาคร 74000'
  },
  {
    text: 'พระราม 2 (CTX พระราม2 แสมดำ)',
    desc: '📍พระราม 2 (CTX พระราม2 แสมดำ)📍',
    value: 'พระราม 2 (CTX พระราม2 แสมดำ)',
    location: [
      { lat_long: '13.64608090445843, 100.41479997140699', id: '2021-08-30T05:38:54.613Z' }
    ],
    shopCharg: 30,
    filterName: 'drop24',
    timePeriod: '10:00 - 15:00',
    displayString:
      'ปั้มน้ำมันคาเท็กซ์ สาขา พระราม2  แสมดำ 9 111 ซอย พระรามที่ 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
  },
  {
    text: 'พระราม 2 (PTT พระราม2 กม.7)',
    desc: '📍พระราม 2 (PTT พระราม2 กม.7)📍',
    value: 'พระราม 2 (PTT พระราม2 กม.7)',
    location: [
      { lat_long: '13.653654824300476, 100.42480662395745', id: '2021-08-30T05:38:54.613Z' }
    ],
    shopCharg: 30,
    filterName: 'drop25',
    timePeriod: '10:00 - 15:00',
    displayString:
      'ปตท. สาขา กรุงเทพฯ-พระราม 2 กม.7   744 ม.6 ถ. พระราม 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
  },
  {
    text: 'ดอนเมือง (PTTสรงประภา)',
    desc: '📍ดอนเมือง (PTTสรงประภา)📍',
    value: 'ดอนเมือง (PTTสรงประภา)',
    location: [
      { lat_long: '13.927687464799938, 100.58518389346402', id: '2021-08-30T05:38:54.613Z' }
    ],
    shopCharg: 30,
    filterName: 'drop26',
    timePeriod: '14:00 - 18:00',
    displayString:
      'ปตท.สรงประภา ดอนเมือง  , 372 ถนน สรงประภา แขวง สีกัน เขตดอนเมือง กรุงเทพมหานคร 10210'
  }
]



// WEBPACK FOOTER //
// ./src/constants/nvbb.js